import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

export default {
  init: () => {
    const mainText = document.querySelectorAll('.split-text');

    const animateOnView = (text) => {
      const splitText = new SplitType(text, {
        types: "lines",
        lineClass: "split-child"
      });

      splitText.lines.forEach((line) => {
        const parentWrapper = document.createElement('div');
        parentWrapper.classList.add('split-parent');
        line.parentNode.insertBefore(parentWrapper, line);
        parentWrapper.appendChild(line);
      });

      gsap.from(splitText.lines, {
        opacity: 0,
        yPercent: 100,
        duration: 1.5,
        ease: "power4.out",
        stagger: 0.6,
        scrollTrigger: {
          trigger: splitText.lines,
          start: "top 90%",
          end: "bottom 20%",
          toggleActions: "play none none none",
        },
      });
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateOnView(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });

    mainText.forEach((text) => {
      observer.observe(text);
    });
  }
};
